import { IDotThiActionTypes } from "../../action-types/to-chuc-thi/IDotThiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDotThiReducer } from "../../reducer-model/to-chuc-thi/IDotThiReducer";

const iniState: IDotThiReducer = {
    status: eReducerStatusBase.is_not_initialization,
    dotThis: [],
}

export const dotThiReducer = (state: IDotThiReducer = iniState, action: IDotThiActionTypes): IDotThiReducer => {
    switch (action.type) {
        case "DOT_THI_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "DOT_THI_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                dotThis: action.payload
            };
        case "DOT_THI_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        default:
            return state;
    }
}